/**
 * **Vollbild auch dort, wo nur die alten Namen abgefragt werden.**
 *
 * Der Player der Sendungsdetailseiten kommt aus dem Paket
 * `dailyme-web-player-slot`. Dessen `requestFullScreenPlayer` fragt der Reihe
 * nach ab: `webkitRequestFullscreen`, `webkitRequestFullScreen`,
 * `msRequestFullscreen`, `requestFullScreen`, `webkitEnterFullscreen`,
 * `mozRequestFullScreen`. Die **genormte** `requestFullscreen` steht in dieser
 * Liste nicht.
 *
 * Am 29.08.2026 gemessen: ein Klick auf den Vollbildknopf loest genau **einen**
 * Aufruf aus, und zwar `webkitRequestFullscreen`. In Chrome und Safari gibt es
 * den Namen noch, dort faellt das nicht auf. In Firefox gibt es weder ihn noch
 * `msRequestFullscreen` noch `requestFullScreen` (das mit grossem S hat es nie
 * gegeben) — uebrig bliebe `mozRequestFullScreen`, das aktuelle Fassungen nicht
 * mehr mitbringen. Der Knopf tut dort also nichts.
 *
 * Das Paket liegt in einem fremden Verzeichnis, in das hier nicht geschrieben
 * wird. Statt den Aufruf zu aendern, wird deshalb der **Name** bereitgestellt:
 * fehlt `webkitRequestFullscreen`, zeigt er auf die genormte Fassung. Dieselbe
 * Ueberlegung fuer das Verlassen des Vollbilds.
 *
 * Wo es die alten Namen wirklich gibt, aendert diese Datei nichts — sie legt
 * nur an, was fehlt.
 */
export default function vollbildBrueckeLegen() {
    if (typeof Element === 'undefined') return;
    const p = Element.prototype;
    if (!p.webkitRequestFullscreen && p.requestFullscreen) {
        p.webkitRequestFullscreen = function () {
            const v = this.requestFullscreen();
            /* Die genormte Fassung liefert ein Versprechen; die alten Namen
               taten das nicht. Ein unbehandelter Fehlschlag landete sonst als
               „Uncaught (in promise)" in der Konsole. */
            if (v && v.catch) v.catch(() => {});
            return v;
        };
    }
    if (typeof document === 'undefined') return;
    if (!document.webkitExitFullscreen && document.exitFullscreen) {
        document.webkitExitFullscreen = function () {
            const v = document.exitFullscreen();
            if (v && v.catch) v.catch(() => {});
            return v;
        };
    }
}
